import * as React from 'react';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Gateway from '../Gateway';
import { useTheme } from '../../../../theme';
import { PaymentPage, PaymentType } from '../../../types';
import Button from '../../../../Button';
import { CashMethodFragment, CompletePaymentMutationVariables } from '@websky/graphql';
import { Money } from '../../../../Money';

interface Props {
	isPreOpened?: boolean;
	frameInfo: CashMethodFragment;
	headerTitle?: string;
	type: PaymentType;
	onCompletePayment: (values: Omit<CompletePaymentMutationVariables, 'orderId'>) => Promise<boolean>;
	onClick: (page: PaymentPage) => void;
}

const Cash: React.FC<Props> = ({ children, isPreOpened, frameInfo, headerTitle, type, onCompletePayment, onClick }) => {
	const { Cash: css } = useTheme('PaymentForm');
	const { t } = useTranslation('PaymentForm');

	const onCompletePaymentHandler = useCallback(() => onCompletePayment({ transactionId: frameInfo.transactionId }), [
		onCompletePayment,
		frameInfo
	]);

	const onClickGateway = useCallback(
		() =>
			onClick({
				title: headerTitle,
				type: PaymentType.Cash,
				content: (
					<div className={css.content}>
						<Button onClick={onCompletePaymentHandler}>
							{t('Pay')}
							<Money money={frameInfo.totalPrice} />
						</Button>
					</div>
				)
			}),
		[onCompletePayment, onClick, frameInfo]
	);

	useEffect(() => {
		if (isPreOpened) {
			onClickGateway();
		}
	}, [isPreOpened]);

	return <Gateway header={children} onClick={onClickGateway} type={type} paymentType={PaymentType.Cash} />;
};

export default Cash;
